import { makeAction } from "async-action-creator";
import * as R from "ramda";
import { notification } from "antd";
import download from "downloadjs";

import { createApiThunk } from "../../utils/thunk";
import api from "../../utils/api";
import i18n from "../../i18n";
import history from "../../history";

export const CREATE_TEAM = makeAction("team/CREATE_TEAM");
export const UPDATE_TEAM = makeAction("team/UPDATE_TEAM");
export const SELECT_TEAM = makeAction("team/SELECT_TEAM");
export const DESELECT_TEAM = makeAction("team/DESELECT_TEAM");
export const EXPORT_TEAM_CANDIDATES = makeAction("team/EXPORT_TEAM_CANDIDATES");

export const createTeam = createApiThunk({
  action: CREATE_TEAM,
  request: (team, { company }) => api.team.create(company.id, team),
  onResolved: ({ response: { id } }) => {
    history.push(`/equipos/${id}`);
    notification.success({
      message: i18n.t("global:good"),
      description: i18n.t("toasts:team.created")
    });
  }
});

export const updateTeam = createApiThunk({
  action: UPDATE_TEAM,
  request: team =>
    api.team.update(team.idCompany, team.id, R.pick(["name", "users"], team)),
  onResolved: () =>
    notification.success({
      message: i18n.t("global:good"),
      description: i18n.t("toasts:team.updated")
    })
});

export const exportTeamCandidates = createApiThunk({
  action: EXPORT_TEAM_CANDIDATES,
  request: async (id, { company }) => {
    const data = await api.team.exportCandidates(id, company.id);
    return download(data, "candidates.csv", "text/plain");
  }
});
